import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a9712350&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@hokify/shared-components/assets/styles/new_headings.scss?vue&type=style&index=0&id=a9712350&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=a9712350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webpack@4.47.0__vue-te_eoxntyycrqiuiceqfmr2hlaiyy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9712350",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports